<template>
  <div class="card assets-table">
    <header class="card-header has-background-dark">
      <p class="card-header-title has-text-light">
        ASSETS
        <b-taglist attached class="card-header-tag">
          <b-tag type="is-light">{{ total }}</b-tag>
        </b-taglist>
      </p>
      <div class="buttons has-addons">
        <button :class="`button is-small ${activeTab === $options.tabs[0] ? 'is-active' : ''}`" @click="activeTab = $options.tabs[0]">TYPE</button>
        <button :class="`button is-small ${activeTab === $options.tabs[1] ? 'is-active' : ''}`" @click="activeTab = $options.tabs[1]">LIST</button>
      </div>
      <div class="buttons">
        <button class="button is-small is-info" @click="$emit('update:mode', 'create')" :disabled="mode === 'create'">CREATE</button>
        <button :class="`button is-small is-info ${importing ? 'is-loading' : ''}`" @click="onImport">IMPORT</button>
      </div>
      <input type="file" @change="onFileInputChange" class="is-sr-only" accept=".osm, .xml" ref="fileInput">
    </header>
    <div class="card-content" ref="scrollableElement">
      <table-class @check="onCheck" :total.sync="total" :ref="$options.tabs[0]" v-if="activeTab === $options.tabs[0]"></table-class>
      <table-single :scrollable-element="scrollableElement" :selected="selected" @select="onSelect" :checked="checked" @check="onCheck" :total.sync="total" :ref="$options.tabs[1]" v-if="activeTab === $options.tabs[1]"></table-single>
    </div>
  </div>
</template>

<script>
import TableSingle from "./tableSingle";
import TableClass from "./tableClass";
import { AssetService } from "@/services/asset.service.js";

export default {
  tabs: ["type", "list"],
  props: {
    mode: {
      type: String
    },
    selected: {
      type: Object,
      default: () => {}
    },
    checked: {
      type: Array,
      default: () => []
    }
  },
  components: {
    TableSingle,
    TableClass
  },
  data: () => ({
    assetService: AssetService,
    activeTab: null,
    total: 0,
    scrollableElement: null,
    importing: false
  }),
  created() {
    this.activeTab = this.$options.tabs[0];
  },
  mounted() {
    this.scrollableElement = this.$refs.scrollableElement;
    this.fetch();
  },
  watch: {
    activeTab() {
      this.fetch();
    }
  },
  methods: {
    fetch() {
      this.$nextTick(async () => {
        await this.$refs[this.activeTab].fetch();
      });
    },
    onSelect(selected) {
      this.$emit("update:selected", selected);
    },
    onCheck(checked) {
      if (checked.length > 0) {
        this.$emit("update:selected", checked[checked.length - 1]);
      } else {
        this.$emit("update:selected", null);
      }

      this.$emit("update:checked", checked);
    },
    onImport() {
      this.$refs.fileInput.click();
    },
    onFileInputChange(e) {
      const file = e.target.files[0];

      let formData = new FormData();
      formData.append("file", file);

      this.importing = true;

      AssetService.import(formData).then(
        response => {
          this.$buefy.toast.open({
            message: "IMPORT SUCCESSFUL",
            type: "is-info",
            position: "is-top-right"
          });
          this.$refs.fileInput.value = "";
          this.fetch();
          this.importing = false;
        },
        error => {
          this.importing = false;
        }
      );
    }
  }
};
</script>

<style lang="scss">
.assets-table {
  .card-header {
    .buttons {
      padding-right: 0.75em;
      margin-bottom: -0.5rem;
    }
  }
  .card-header-tag {
    margin-left: 8px;
    .tag {
      margin-bottom: 0;
      margin-top: -0.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Assets/list/partials/table.vue